export const USER_ROLES_PROP = 'https://web.checkingin.co/roles';

export const ADMIN_PERMISSION = 'Admin';
export const CONTENT_CREATOR_PERMISSION = 'Content-Creator';
export const CLINICIAN_PERMISSION = 'Healing-Staff-Member';
export const CLINICIAN_ADMIN_PERMISSION = 'CheckingIn-Admin';
